
import React, { useEffect, useState } from "react";
import { Col, Button, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useIncidents } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange"; 
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";
import { DownloadOutlined } from "@ant-design/icons";

const sub_project = { xxl: 7, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 };
const accident = { xxl: 7, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 };
const incident = { xxl: 7, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 };

const headerLayout = [
  { ...sub_project, header: "Sub Project" },
  { ...accident, header: "Has there been any accident?" },
  { ...incident, header: "Has there been any incident?" },
];

const IncidentAndAccidents = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { incidents, pagination, loading } = useIncidents(packageId, startDate, endDate, currentPage, pageSize);

  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name; 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const handleDownload = (url) => {
    if (url) {  
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <div style={{ width: "100%", padding: "24px" }}>
        <ActionBar actionButtonProp={{
            title: `${packageName || "==//=="}: Incidents and Accidents`,
          }}
        />


        <div className="prst-table">
          <CustomList
            itemName={` Incidents`}
            items={incidents}
            page={currentPage}
            itemCount={pagination?.total || (incidents?.length ?? 0)}
            loading={loading}
            headerLayout={headerLayout}
            renderListItem={({ item }) => (
              <ListItem
                name={item?.sub_project?.name || "==//=="}
                key={item.id}
                item={item}
                isPackage={false}
                onClick={() => handleRowClick(item)}
                style={{
                  backgroundColor:
                    activeItem?.package_number === item?.package_number
                      ? "#f0f0f0"
                      : "transparent",
                }}
              >
                <Col {...sub_project} className="contentEllipse" data-label="Sub Project">
                  {item?.sub_project?.name || "==//=="}
                </Col>

                <Col {...accident} data-label="Accident">
                  {item?.is_accident ? (
                    <>
                      <span style={{ marginRight: "10px" }}>Yes</span>
                      <Button
                        className="styled-button"
                        icon={<DownloadOutlined />}
                        onClick={() => handleDownload(item?.accident)}
                      >
                        Download RCA Report
                      </Button>   
                    </>
                  ) : (
                    <span>No</span>
                  )}
                </Col>

                <Col {...incident} className="contentEllipse" data-label="Incident">
                  {item?.is_incident ? (
                    <>
                      <span style={{ marginRight: "10px" }}>Yes, </span>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100px",
                        }}
                      >
                        {item?.incident}
                      </span>
                    </>
                  ) : (
                    <span>No</span>
                  )}
                </Col>
                
                <div className="view-card-details" onClick={() => handleRowClick(item)}>
                  View Details
                </div>
              </ListItem>
            )}
          />
        </div>

        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        )}
      </div>

  {activeItem && (
          <Drawer
            title={`Incidents and Accidents`}
            placement="right"
            closable={true}
            onClose={handleCloseDrawer}
            visible={visible}
            width={720}
          >
            <p>
              <strong>Sub Project Name:</strong>{" "}
              {activeItem?.sub_project.name || "==//=="}
            </p>
            <p>
              <strong>Accident Root Cause Analysis report:</strong>{" "}
              {activeItem?.is_accident ? (
                <Button
                  className="styled-button"
                  onClick={() => handleDownload(activeItem?.accident)}
                >
                  Download RCA Report
                </Button>
              ) : (
                <span>No</span>
              )}
            </p>
            <p>
              <strong>Incident Root Cause Analysis report:</strong>{" "}
              {activeItem?.is_incident ? (
                <p>{activeItem?.incident}</p>
              ) : (
                <span>No</span>
              )}
            </p>
          </Drawer>
        )}
    </>
  );
};

export default IncidentAndAccidents;
